import React from "react";
import { Badge } from "@/components/ui/badge";
import DashboardWidget from "@/components/DashboardWidget";

interface AnalyticsStats {
  trafficSources: {
    utm: Record<string, number>;
    searchEngines: Record<string, number>;
    referrers: Record<string, number>;
  };
}

interface TrafficSummaryWidgetProps {
  stats: AnalyticsStats | null;
}

export const TrafficSummaryWidget: React.FC<TrafficSummaryWidgetProps> = ({
  stats,
}) => {
  const totalUTMVisitors = Object.values(
    stats?.trafficSources.utm || {},
  ).reduce((a, b) => a + b, 0);
  const totalSearchVisitors = Object.values(
    stats?.trafficSources.searchEngines || {},
  ).reduce((a, b) => a + b, 0);
  const totalReferralVisitors = Object.values(
    stats?.trafficSources.referrers || {},
  ).reduce((a, b) => a + b, 0);

  return (
    <DashboardWidget id="traffic-summary" title="Traffic Sources Summary">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="flex justify-between items-center p-3 bg-blue-50 rounded-lg">
          <span className="font-medium">UTM Sources</span>
          <Badge variant="secondary">{totalUTMVisitors} visitors</Badge>
        </div>
        <div className="flex justify-between items-center p-3 bg-green-50 rounded-lg">
          <span className="font-medium">Search Engines</span>
          <Badge variant="secondary">{totalSearchVisitors} visitors</Badge>
        </div>
        <div className="flex justify-between items-center p-3 bg-purple-50 rounded-lg">
          <span className="font-medium">Direct/Referral</span>
          <Badge variant="secondary">{totalReferralVisitors} visitors</Badge>
        </div>
      </div>
    </DashboardWidget>
  );
};

export default TrafficSummaryWidget;
